const getters = {
  answer:(state)=>state.base.answer,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getter.js